import { AuthContext } from '@/contexts/auth-context';
import { use } from 'react';

export function useAuth() {
  const context = use(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
